// Aufnahmeantrag: the Geschäftsstelle only accepts joining on the 1st of a
// month, so the day is fixed and the user only picks month and year.
export const JOIN_DAY = "01";

const JOIN_YEAR_COUNT = 2;

// Month ("1"-"12") and year ("JJJJ") as the select fields deliver them.
// Returns "01.MM.JJJJ", or "" while the selection is incomplete so the backend
// rejects it like an empty date field.
export const joinDateToStr = (month: string, year: string): string => {
  const monthNum = Number(month);
  if (!Number.isInteger(monthNum) || monthNum < 1 || monthNum > 12) {
    return "";
  }
  if (!/^\d{4}$/.test(year)) {
    return "";
  }
  return `${JOIN_DAY}.${("0" + monthNum).slice(-2)}.${year}`;
};

export const joinYearOptions = (today: Date): Array<number> =>
  Array.from(
    { length: JOIN_YEAR_COUNT },
    (_, index) => today.getFullYear() + index
  );
